import { RecordPatch, RecordSlot } from '#record/model';
import { utils } from 'apprise-core/utils';
import { TenantReference } from 'apprise-core/tenant'
import { TagReference } from 'apprise-core/tag'
import { trxauthzType } from './constants';
import { DeepPartial } from 'apprise-core/utils';

export type TrxAuthPatch = RecordPatch<typeof trxauthzType> 

export type TrxAuthzs = RecordSlot & {

    authzs: Record<TenantReference, TrxAuthz[]>

  
}

export type TrxAuthz = {

    timestamp: string
    type: TagReference
    from: string
    to: string

    // revocation?: boolean
}


// minimal skeleton for missing slots.
export const newTrxAuthzSlot = () => {

    const partials : DeepPartial<TrxAuthzs> = {

        id: utils().mint('TRX'),
        authzs: {}

    } 

    return partials as TrxAuthzs
}